import React, { useEffect } from 'react';

import { useCasinoFavorites } from '@atlas/core';

import CasinoLoadMoreButton from 'components/Casino/components/CasinoLoadMoreButton';
import GamesInfiniteLoader from 'components/Casino/components/GamesInfiniteLoader';

export const CasinoFavoritesGames = () => {
  const { games, hasMore, isLoading, loadMore } = useCasinoFavorites();
  const hasLoadMore = hasMore && !isLoading;

  useEffect(() => {
    loadMore();
  }, []);

  return (
    <div className="casino__games--list-wrapper">
      <GamesInfiniteLoader
        games={games}
        hasLoadMore={hasLoadMore}
        isFavorites
        loading={isLoading}
      />
      {hasLoadMore && <CasinoLoadMoreButton handleClick={loadMore} />}
    </div>
  );
};
